<div [formGroup]="signatureForm">
  <div>
    <p style="margin-bottom: 0.5rem;" *ngIf="nameError"><span class="error">Enter your full name</span> and
      then <span class="">sign in
        the box below</span>.</p>
  </div>
  <div class="f-row f-a-center">
    <input [ngClass]="{
      'is-invalid':
        f['FullName'].invalid &&
        (f['FullName'].dirty || f['FullName'].touched)
    }" placeholder="Your full name" type="text" value="" formControlName="FullName">
    <span class="f-grow"></span>
    <span style="margin-left: 1rem;">Date Signed: {{todayDate}}</span>
  </div>


  <div class="signature-pad">
    <div class="signature-pad--body">
      <canvas #sPad width="800" height="250" [ngClass]="{'is-invalid':signatureError}"></canvas>
    </div>
  </div>

  <div *ngIf="signatureNotValid">
    <p class="text-danger">Please enter a valid signature.</p>
  </div>

  <div class="f-row mobile-row">
    <button class="round" (click)="clear()">
      <i class="i-eraser"></i>
      <span>clear</span>
    </button>

    <button class="round" (click)="undo()">
      <i class="i-undo"></i>
      <span>undo</span>
    </button>


    <span class="f-grow"></span>
    <button [appLogEvent] class="call-to-action round" type="button" (click)="submitData()">
      <i class="i-check_mark"></i>
      <span>submit signature</span>
    </button>
  </div>

</div>
